import { ReactNode } from "react";

import { useSidebarContext } from "@/components/General/Sidebar/context/sidebar.context";
import { Depth } from "@/context/depth.context";
import { Mapped } from "@/context/mapped.context";

type Props = {
    children?: ReactNode;
};

export const SubCategories = ({ children }: Props) => {
    const { categories } = useSidebarContext();

    const subCategories = categories.slice(1);

    return (
        <Depth initial={1}>
            <Mapped array={subCategories}>{children}</Mapped>
        </Depth>
    );
};
